import './archive-outro.scss';
export default (() => {});